module.exports = __webpack_public_path__ + "img/label-1DUPLO.4206c76f.jpeg";